<template>
  <div class="cont-pg">
    <div class="overlay-universal"></div>
    <div class="rel-pos">
      <HeaderComponent />
      <HelpComponent />
    </div>
  </div>
</template>

<script>

import HeaderComponent from './HeaderComponent.vue';
import HelpComponent from './HelpComponent.vue';

export default {
  components: {
    HeaderComponent,
    HelpComponent
  }
};
</script>

<style>

body {
    font-family: 'Montserrat', sans-serif;
    margin: 0;
    padding: 0;
    background-color: #1e1e1e;
    color: #fff;
    font-size: 12px;
}

.cont-pg {
    padding: 20px;
}

</style>